import { useStaticQuery, graphql } from "gatsby";
import { WorldCovidCasesQuery } from "../../../graphql-types";

export const useWorldCovidCases = () => {
  const worldCovidCasesData = useStaticQuery<WorldCovidCasesQuery>(graphql`
    query WorldCovidCases {
      askAboutQuery {
        covidCaseOwidByCountry(country: "World") {
          alias
          displayName
          latest {
            date
            totalCases
            totalCasesPerMillion
            averageNewCases
            totalDeaths
            infectionRate
          }
          data {
            date
            averageNewCases
            infectionRate
          }
        }
      }
    }
  `);

  return worldCovidCasesData.askAboutQuery.covidCaseOwidByCountry;
};
